export const GRID = {
    id: 1,
    name: 'Grid',
    value: 'GRID',
};
export const GRID_TIMESTAMP = {
    id: 2,
    name: 'Grid with Timestamp',
    value: 'GRID_TIMESTAMP',
};
export const LIST = {
    id: 3,
    name: 'List',
    value: 'LIST',
};
export const LIST_DETAIL = {
    id: 4,
    name: 'List with Detail',
    value: 'LIST_DETAIL',
};
export const Basic = [GRID, GRID_TIMESTAMP, LIST, LIST_DETAIL];
export const BasicByValue = Basic.reduce((hash, type) => {
    hash[type.value] = type;
    return hash;
}, {});
export const BasicValues = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicValues,
    GRID,
    GRID_TIMESTAMP,
    LIST,
    LIST_DETAIL,
};
